<app-header label="Role"></app-header>
<form [formGroup]="form" class="p-3">
    <div class="bg-white border border-gray-300 shadow-sm p-4 rounded-lg">
        <div class="flex flex-col md:flex-row gap-4 mb-6">
            <app-text-input [is_disabled]="params.view" class="flex-1" label="Role Name" formControlName="name"></app-text-input>
            <app-select-input [is_disabled]="params.view" class="flex-1" label="Access Level" formControlName="belongs_to" [options]="access"></app-select-input>
            <app-select-input [is_disabled]="params.view" class="flex-1" label="Landing Page" formControlName="landing_page" [options]="landing_page_options"></app-select-input>
        </div>
        <h2 class="text-xl font-semibold mb-4 border-b pb-2">Permissions</h2>
        <div formArrayName="permissions" class="space-y-6">
            <ng-container *ngFor="let section of permissions_FA.controls; let i = index" [formGroupName]="i">
                <div class="flex justify-between items-center">
                    <p class="font-semibold text-gray-800">{{ section.get('section')?.value }}</p>
                    <label class="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" formControlName="toggle" class="sr-only peer"
                            (change)="on_section_toggle(section)" />
                        <div class="w-12 h-6 bg-gray-300 rounded-full peer-checked:bg-green-500 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:h-5 after:w-5 after:rounded-full after:shadow-md  after:transition-all peer-checked:after:translate-x-6">
                        </div>
                    </label>
                </div>

                <div *ngIf="section.get('toggle')?.value" formArrayName="sub_sections" class="pl-6 mt-2 space-y-3">
                    <ng-container *ngFor="let sub of get_sub_sections(section).controls; let j = index"
                        [formGroupName]="j">
                        <p class="font-medium text-gray-700">{{ sub.get('name')?.value }}</p>

                        <div class="grid grid-cols-2 md:grid-cols-6 gap-3 mt-1" formArrayName="actions">
                            <label *ngFor="let act of get_actions(sub).controls; let k = index" [formGroupName]="k"
                                class="flex items-center gap-2 text-gray-600 hover:text-gray-900 cursor-pointer">
                                <input type="checkbox" formControlName="value"
                                    (change)="on_action_change(section, sub, k)"
                                    class="h-4 w-4  border-gray-300 rounded">
                                <span>{{ act.get('name')?.value }}</span>
                            </label>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="section.get('toggle')?.value && get_actions(section).length" formArrayName="actions"
                    class="pl-6 mt-2 grid grid-cols-2 md:grid-cols-6 gap-3">
                    <label *ngFor="let act of get_actions(section).controls; let a = index" [formGroupName]="a"
                        class="flex items-center gap-2 text-gray-600 hover:text-gray-900 cursor-pointer">
                        <input type="checkbox" formControlName="value" (change)="on_action_change(section, null, a)"
                            class="h-4 w-4 border-gray-300 rounded">
                        <span>{{ act.get('name')?.value }}</span>
                    </label>
                </div>

            </ng-container>
        </div>
        <div class="flex justify-end mt-6 gap-3">
            <app-button label="Cancel" type="button" (click)="gs.go_back()" class="text-black"></app-button>
            <app-button [label]="params.id ? 'Update' :'Add'" type="button" [disabled]="params.view || isSubmitting" (click)="submit()" class="text-black"></app-button>
        </div>
    </div>
</form>